const AboutCard = ({ color, text }) => {
  return (
    <div
      className=" flex justify-center items-center
        w-[100px] h-[40px]
        sm:w-[150px] sm:h-[50px]
        md:w-[180px] md:h-[60px]

        bg-white/40 backdrop-blur-md
         border border-gray-300 rounded-md
       gap-2 sm:gap-3
        px-2 sm:px-3 md:px-4

      
      "
    >
      <div
        className="
        w-8 h-8 
        sm:w-9 sm:h-9 
        md:w-10 md:h-10
        
     
        flex items-center justify-center
      "
      >
        <div
          className={`w-5 h-5 sm:w-6 sm:h-6 md:w-10 md:h-10  rounded-md  ${color}`}
        />
      </div>

      <p
        className="
        text-[8px] sm:text-xs md:text-sm
        font-medium text-black 
        leading-tight
      "
      >
        {text}
      </p>
    </div>
  );
};

export default AboutCard;
